import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding, inject,
  Input,
  Output,
} from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { FormsModule } from '@angular/forms';
import { XIconButtonComponent } from '../x-icon-button/x-icon-button.component';
import { NgIf } from '@angular/common';
import { XDividerComponent } from '../x-divider/x-divider.component';
import {MediaQueryService} from "../../../services/media-query.service";

@Component({
  selector: 'app-x-search',
  standalone: true,
  imports: [SvgIconComponent, XIconButtonComponent, FormsModule, NgIf, XDividerComponent],
  templateUrl: './x-search.component.html',
  styleUrl: './x-search.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XSearchComponent {
  @Input() value = '';
  @Input() mobile = false;
  @Input() withSearchButton: boolean = false;
  @Input() placeholder: string = 'Type to search...';
  @HostBinding('class.active') @Input() isActive: boolean = false;
  @Output() valueChange = new EventEmitter<string>();
  @Output() forceSearch = new EventEmitter<void>();
  @Output() focus = new EventEmitter<void>();
  @Output() blur = new EventEmitter<void>();

  public mediaQuery = inject(MediaQueryService);

  public onValueChange(value: string | null | undefined): void {
    const safeValue = value ?? '';
    this.valueChange.emit(safeValue);
  }

  public onFocus() {
    this.focus.emit();
  }

  public onBlur() {
    this.blur.emit();
  }
}
